import React from "react";
import ReactDOM from "react-dom";
import RestaurantsMap from "./containers/RestaurantsMap";
import {isEmpty} from "lodash";

export const initRestaurantsMap = className => {
  let elements = document.querySelectorAll(`.${className}`);
  if (!isEmpty(elements)) {
    for (let element of elements) {
      ReactDOM.render(<RestaurantsMap />, element);
    }
  }
};
